import { render, staticRenderFns } from "./CompareItem.vue?vue&type=template&id=b0fa5d3e"
import script from "./CompareItem.vue?vue&type=script&lang=js"
export * from "./CompareItem.vue?vue&type=script&lang=js"
import style0 from "./CompareItem.vue?vue&type=style&index=0&id=b0fa5d3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports